import React from 'react';
import { ISvgIconProps, } from './interface';
import { SvgIcon, } from './SvgIcon';

export const WidgetPieIcon = (props: ISvgIconProps) => {
  return <SvgIcon {...props}>
    <g fill="#444" transform="scale(0.0234375 0.0234375)"><path d="M556 556h382q-14 152-122 260t-260 122v-382zM556 86q152 14 260 122t122 260h-382v-382zM470 86v852q-162-16-273-138t-111-288 111-288 273-138z" /></g>
  </SvgIcon>;
};
